<h2 class="sr-only">{{ "DossiernummerdSuche" | translate }}</h2>
<form (ngSubmit)="onSubmit()" [meta]="dossiernummer" #form="ngForm">
  <cap-form-row column-classes="col-md-3,col-md-6">
    <cap-form-control invalidKey="BauortMussVorhandenSein" labelKey="Bauort">
      <cap-bauort
        (blur)="onTouched()"
        (ngModelChange)="dossiernummer && (dossiernummer.bauortEntry = $event)"
        [hasfocus]="true"
        [ngModel]="dossiernummer && dossiernummer.bauortEntry"
        class="typeahead-holder"
        name="bauort"
        required></cap-bauort>
      <button (click)="emptyBauorteSearch()" class="btn btn-white" tabindex="-1" type="button">
        <span class="fas fa-times"></span>
      </button>
    </cap-form-control>
  </cap-form-row>
  <cap-form-row column-classes="col-md-3,col-md-6">
    <cap-form-control invalidKey="EingabeMussValideBaudossiernummerSein" labelKey="AmtlicheBaudossiernummer">
      <input
        (ngModelChange)="dossiernummer && (dossiernummer.baudossierNummer = $event)"
        [ngModel]="dossiernummer && dossiernummer.baudossierNummer"
        id="baudossierNummer"
        name="baudossierNummer"
        required
        type="text" />
    </cap-form-control>
  </cap-form-row>
  <cap-form-row column-classes="col-md-3,col-md-6">
    <cap-form-control invalidKey="EingabeMussValiderBaudossiernummerZusatzSein" labelKey="AmtlicheBaudossiernummerZusatz">
      <input
        (ngModelChange)="dossiernummer && (dossiernummer.baudossierNummerZusatz = $event)"
        [ngModel]="dossiernummer && dossiernummer.baudossierNummerZusatz"
        id="baudossierNummerZusatz"
        name="baudossierNummerZusatz"
        type="text" />
    </cap-form-control>
  </cap-form-row>

  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">
        {{ "Zurücksetzen" | translate }}
      </button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
